






















import { Component, Prop, Vue } from 'vue-property-decorator';
import { ReportBlockWrapper } from '@/components/report/ReportBlockWrapper';
import { ReportBlocks } from '@/components/report/ReportBlocks';
import { Common } from '@/core/Common';
import { FView } from '@/core/FView';


@Component({
  components: { }
})
export default class extends Vue {
  created() {
    document.body.style.backgroundColor = "#FFF";
  }

  getDisplayedBlocks() : ReportBlockWrapper[] {
    return ReportBlocks.GetAvailable();
  }

  getFrom() {
    return Common.FormatDate(FView.Get().dataManager.GetCurrentRange().start);
  }

  getTo() {
    return Common.FormatDate(FView.Get().dataManager.GetCurrentRange().end);
  }

  getPlace() {
    return FView.Get().dataManager.GetPlace().getFullName();
  }
}
